'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reduxForm = require('redux-form');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Survey = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { initialize: _reduxForm.initialize }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Survey, _Component);

  function Survey() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Survey);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Survey.__proto__ || (0, _getPrototypeOf2.default)(Survey)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (data) {
      window.alert('Data submitted! ' + (0, _stringify2.default)(data));
      _this.props.initialize('survey', {});
    }, _this.handleInitialize = function () {
      _this.props.initialize('survey', {
        name: 'Little Bobby Tables',
        email: 'bobby@gmail.com',
        occupation: 'Redux Wizard',
        currentlyEmployed: true,
        sex: 'male'
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Survey, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'h1',
          null,
          'Survey'
        ),
        _react2.default.createElement(_reactHelmet2.default, { title: 'Survey' }),
        _react2.default.createElement(
          'p',
          null,
          'This is an example of a form in redux in which all the state is kept within the redux store. All the components are pure "dumb" components.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Things to notice:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'No validation errors are shown initially.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Validation errors are only shown onBlur'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Validation errors are hidden onChange when the error is rectified'
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'code',
              null,
              'valid'
            ),
            ', ',
            _react2.default.createElement(
              'code',
              null,
              'invalid'
            ),
            ', ',
            _react2.default.createElement(
              'code',
              null,
              'pristine'
            ),
            ' and ',
            _react2.default.createElement(
              'code',
              null,
              'dirty'
            ),
            ' flags are passed with each change'
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'em',
              null,
              'Except'
            ),
            ' when you submit the form, in which case they are shown for all invalid fields.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'If you click the Initialize Form button, the form will be prepopupated with some values and the ',
            _react2.default.createElement(
              'code',
              null,
              'pristine'
            ),
            ' and ',
            _react2.default.createElement(
              'code',
              null,
              'dirty'
            ),
            ' flags will be based on those values.'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Pardon the use of ',
          _react2.default.createElement(
            'code',
            null,
            'window.alert()'
          ),
          ', but I wanted to keep this component stateless.'
        ),
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', margin: 15 } },
          _react2.default.createElement(
            'button',
            { className: 'btn btn-primary', onClick: this.handleInitialize },
            _react2.default.createElement('i', { className: 'fa fa-pencil' }),
            ' Initialize Form'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'The circles to the left of the inputs correspond to flags provided by ',
          _react2.default.createElement(
            'code',
            null,
            'redux-form'
          ),
          ': Touched, Visited, Active, and Dirty.'
        ),
        _react2.default.createElement(_components.SurveyForm, { onSubmit: this.handleSubmit })
      );
    }
  }]);
  return Survey;
}(_react.Component), _class2.propTypes = {
  initialize: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = Survey;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Survey/Survey.js
// module id = 1289
// module chunks = 0